import styled from 'styled-components';

export const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 160px);
  justify-content: center;
  align-items: center;
  background: #fff;

  overflow-x: hidden;

  ${'' /* height: fit-content; */}
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 20px;
    height: fit-content;
  }
  ${
    '' /* @media screen and (max-width: 1024px) {
        height: 850px;
    }

    @media screen and (max-width: 700px) {
        height: 1500px;
    }

    @media screen and (max-width: 480px) {
        height: 1300px;
    } */
  }
`;

export const GalleryWrapper = styled.div`
  max-width: 1000px;
  margin: 36px auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 32px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const GalleryCard = styled.div`
  background: #f3f1ea;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  max-width: 275px;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  ${'' /* transition: all 0.2s easy-in-out; */}

  ${
    '' /* &:hover {
        transition: all 0.2s easy-in-out;
        cursor: pointer;
    } */
  }
`;

export const GalleryIcon = styled.img`
  height: 250px;
  width: 230px;
  margin-bottom: 10px;

  border-bottom: 2px solid #c2c1bb;
  padding-bottom: 15px;
`;

export const GalleryH2 = styled.h2`
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  ${'' /* margin-bottom: 10px; */}
  align-self: flex-start;
  margin-left: 20px;
  height: 40px;
`;
export const GalleryH1 = styled.h1`
  font-size: 32px;
  color: #000;
  margin-bottom: 40px;

  @media screen and (max-width: 1024px) {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 24px;
  }
`;
export const CardDescr = styled.div`
  height: 250px;
  width: 230px;
  margin-bottom: 10px;
  border-bottom: 2px solid #c2c1bb;
  padding-bottom: 15px;
`;
export const CardDescrItem = styled.div`
  color: rgba(0, 0, 0, 0.75);
  font-size: 14px;
  line-height: 16px;
  margin: 15px 0;
`;
